import React from 'react';
import {Box} from '@mui/material';
import {QuickTestAccounts} from './QuickTestAccounts';

interface RegressionModalProps {
  setRegressionModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const RegressionModal: React.FC<RegressionModalProps> = ({setRegressionModal}) => {
  return (
    <Box>
      <QuickTestAccounts
        separateActions
        onCloseAllModals={() => setRegressionModal(false)}
      />
    </Box>
  );
};
